import Vue from 'vue'
import Router from 'vue-router'
const login = () => import('@/views/login/login')
const noFount = () => import('@/views/noFount/index')
import Cookies from "js-cookie";

//原来项目
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/login',
      name: 'Login',
      component: login,
      meta: {
        title: '悠语文管控台'
      }
    },
    {
      path: '/404',
      name: 'noFount',
      component: noFount,
      meta: {
        title: '未找到页面'
      }
    },
  ]
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js